import api from "../index";

export const getTermoUsoCadastro = async (code) => {
    try {
        const { data: response } = await api.get(`/Cadastro/TermoUsoCadastro`);
        return response.data;
    } catch (error) {
        throw new Error(error + " R46C0");
    }
};


export const habilitarCampoTelefonePreCadastro = async (code) => {
    try {
        const { data: response } = await api.get(`/Cadastro/HabilitarCampoTelefonePreCadastro`);
        return response.data;
    } catch (error) {
        throw new Error(error + " RED8D");
    }
};
